import numeral from 'numeral'
export const  moneyFormat = (money, haveUnit = true) => {
  return haveUnit ? `${numeral(money).format('0,0.00')} THB` : numeral(money).format('0,0.00')
}
